import "./Home.css";
import OurWork from "../OurWork/OurWork";
import Who from "../who/Who";
import Services from "../Services/Services";

export default function Home() {
  return (
    <>
      <Who />
      <Services />
      <OurWork />
    </>
  );
}
